import { getPartnerDetails } from '../utils/helper'

const getConfigDetails = Object.freeze({
  ENV: process.env.REACT_APP_ENV,
  baseURL: process.env.REACT_APP_BASE_URL,

  // Static IDs
  FACILITY_ID: process.env.REACT_APP_FACILITY_ID,
  FULL_SEASON: process.env.REACT_APP_FULL_SEASON,
  HALF_SEASON: process.env.REACT_APP_HALF_SEASON,
  SIX_PACK: process.env.REACT_APP_SIX_PACK,

  get PARTNER_ID() {
    return getPartnerDetails()?.clients?.partner_id ?? null
  },

  get CLIENT_ID() {
    return getPartnerDetails()?.clients?.id ?? null
  },

  get CLIENT_SECRET() {
    return getPartnerDetails()?.clients?.secret ?? ''
  },

  chiperKey: process.env.REACT_APP_CHIPER_KEY,

  // Google reCAPTCHA v3 (public site key only)
  recaptchaSiteKey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
})

export default getConfigDetails